(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heary-b-reviews-expanded"] && !Shopify.designMode) return;
  try {
    

(() => {
 function initReviews(scope=document) {
  scope.querySelectorAll('[data-heary-reviews]').forEach(section=>{
   if(section.dataset.reviewsReady)return;
   section.dataset.reviewsReady='true';
   const grid=section.querySelector('.thr-grid'), cards=[...grid.querySelectorAll('[data-review-card]')], more=section.querySelector('[data-review-more]'), actions=section.querySelector('.thr-actions'), status=section.querySelector('[data-review-status]');
   const purchaseRow=()=>{const row=document.createElement('div');row.className='thr-product';row.textContent='Purchased: '+(section.dataset.productLabel||'Heary™ hearing aids');return row};
   section.querySelectorAll('.heary-review-expand').forEach(e=>e.remove());
   const badge=()=>{const b=document.createElement('span');b.className='thr-verified';b.innerHTML='<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="m4 8 2.5 2.5L12 5" fill="none" stroke="white" stroke-width="1.8"/></svg> Verified';return b};
   cards.forEach((c,i)=>{c.querySelector('.thr-author')?.append(badge());const row=c.querySelector('.thr-product');if(row)row.replaceWith(purchaseRow());else c.querySelector('.thr-card-body')?.append(purchaseRow());c.hidden=i>=18});
   const dialog=document.createElement('dialog');dialog.className='thr-dialog';dialog.setAttribute('aria-label','All customer reviews');
   const header=document.createElement('div');header.className='thr-dialog-header';header.innerHTML='<strong><span class="thr-green">★★★★★</span> 7,180 reviews</strong><button type="button" class="thr-close" aria-label="Close reviews">×</button>';
   dialog.append(header,grid,actions);section.append(dialog);
   const carousel=document.createElement('div');carousel.className='thr-carousel';carousel.setAttribute('role','region');carousel.setAttribute('aria-label','Customer photo reviews');
   const track=document.createElement('div');track.className='thr-track';track.tabIndex=0;track.setAttribute('aria-label','Swipe or use arrow buttons to see more photo reviews');
   const previous=document.createElement('button');previous.type='button';previous.className='thr-arrow thr-prev';previous.setAttribute('aria-label','Previous photo reviews');previous.textContent='‹';
   const next=document.createElement('button');next.type='button';next.className='thr-arrow thr-next';next.setAttribute('aria-label','Next photo reviews');next.textContent='›';
   let opener=null,oldOverflow='';
   function open(card){section.querySelectorAll('video').forEach(v=>v.pause());opener=document.activeElement;if(!dialog.open){oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal()}
    if(card){const i=cards.indexOf(card);cards.slice(0,i+1).forEach(c=>c.hidden=false);requestAnimationFrame(()=>{card.scrollIntoView({block:'center'});card.focus({preventScroll:true})})}
   }
   header.querySelector('button').onclick=()=>dialog.close();
   dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
   dialog.addEventListener('close',()=>{dialog.querySelectorAll('video').forEach(v=>v.pause());document.body.style.overflow=oldOverflow;opener?.focus({preventScroll:true})});
   const stories = section.hasAttribute('data-stories');
   const aldo = cards.findIndex(c=>c.querySelector('.thr-author')?.firstChild?.textContent.trim()==='Aldo');
   const featured = stories && aldo >= 0 ? cards.slice(0,aldo+1) : cards;
   const photos = featured.filter(card => card.querySelector('img,video'));
   // Repeat the opening cards so the last review slides directly into the first.
   const slides = stories ? photos.concat(photos.slice(0, 5)) : photos;
   slides.forEach((card, index)=>{

    const clone=card.cloneNode(true);clone.hidden=false;clone.removeAttribute('data-review-card');clone.removeAttribute('data-shopify-editor-block');clone.classList.add('thr-slide');clone.tabIndex=0;clone.setAttribute('role','button');clone.setAttribute('aria-label','Read full review by '+card.querySelector('.thr-author').childNodes[0].textContent.trim());
    if (index >= photos.length) {
      clone.dataset.loopCopy = '';
      clone.tabIndex = -1;
      clone.setAttribute('aria-hidden','true');
    }
    clone.querySelectorAll('.thr-date,.thr-more-photos,.heary-review-expand').forEach(e=>e.remove());
    clone.addEventListener('click',e=>{if(!e.target.closest('video,.thr-video-play'))open(card)});clone.addEventListener('keydown',e=>{if(e.target.closest('video,.thr-video-play'))return;if(e.key==='Enter'||e.key===' '){e.preventDefault();open(card)}});track.append(clone);
   });
   carousel.append(previous,track,next);
   if (stories) section.querySelector('.thr-stories-heading').after(carousel); else {
   const summary=section.querySelector('.thr-summary');summary.replaceChildren();
   const all=document.createElement('button');all.type='button';all.className='thr-all';all.innerHTML='<span class="thr-green" aria-hidden="true">★★★★★</span> 4.8 (7,180 reviews)';all.onclick=()=>open();summary.append(all);
   summary.after(carousel);
   }
   section.querySelectorAll('.thr-video').forEach(wrapper=>{
    const video=wrapper.querySelector('video'),button=document.createElement('button');
    button.type='button';button.className='thr-video-play';button.setAttribute('aria-label','Play '+video.getAttribute('aria-label'));
    button.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M5 3v18l16-9z"/></svg>';
    wrapper.append(button);
    button.addEventListener('click',e=>{e.stopPropagation();video.play().catch(()=>{button.hidden=false})});
    video.addEventListener('play',()=>{button.hidden=true});
    video.addEventListener('pause',()=>{button.hidden=false});
    video.addEventListener('ended',()=>{button.hidden=false});
   });
   function shift(direction){track.scrollBy({left:direction*(track.firstElementChild.getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
   function arrows(){previous.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2}
   previous.onclick=()=>shift(-1);next.onclick=()=>shift(1);track.addEventListener('scroll',arrows,{passive:true});new ResizeObserver(arrows).observe(track);arrows();
   if (stories && photos.length > 5) {
    const videos = [...track.querySelectorAll('video')];
    const loopStart = track.querySelector('[data-loop-copy]');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0, previousTime = 0, remainder = 0, loopWidth = 0, holdUntil = 0, touching = false;
    const measure = () => { loopWidth = loopStart.offsetLeft - track.firstElementChild.offsetLeft; };
    new ResizeObserver(measure).observe(track);
    measure();
    const delay = () => { holdUntil = performance.now() + 1500; };
    track.addEventListener('touchstart', () => { touching = true; }, {passive:true});
    for (const event of ['touchend','touchcancel']) track.addEventListener(event, () => { touching = false; delay(); }, {passive:true});
    track.addEventListener('wheel', delay, {passive:true});
    carousel.addEventListener('click', delay);
    function move(now) {
      if (!section.isConnected) return;
      const seconds = previousTime ? Math.min(now - previousTime, 48) / 1000 : 0;
      previousTime = now;
      if (loopWidth && !touching && now > holdUntil && !dialog.open && !document.hidden &&
          !reducedMotion.matches && !track.matches(':focus-within') && !videos.some(video => !video.paused)) {
        remainder += seconds * 32;
        const pixels = Math.floor(remainder);
        remainder -= pixels;
        if (pixels) track.scrollLeft = (track.scrollLeft + pixels) % loopWidth;
      }
      frame = requestAnimationFrame(move);
    }
    new IntersectionObserver(([entry]) => {
      cancelAnimationFrame(frame);
      previousTime = 0;
      if (entry.isIntersecting) frame = requestAnimationFrame(move);
    }).observe(track);
   }
   track.addEventListener('keydown',e=>{if(e.target.closest('video,.thr-video-play'))return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();shift(e.key==='ArrowRight'?1:-1)}});
   document.querySelectorAll('a[href*="#th-reviews"]').forEach(link=>{link.setAttribute('aria-haspopup','dialog');link.addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();open()},true)});
   let extra=null,cursor=0;
   function update(){if(more)more.hidden=cards.every(c=>!c.hidden)&&extra!==null&&cursor>=extra.length}
   function makeCard(review){
    const c=document.createElement('article');c.className='thr-card';c.dataset.reviewCard='';c.tabIndex=-1;
    const body=document.createElement('div');body.className='thr-card-body';
    const author=document.createElement('p');author.className='thr-author';author.textContent=review.name;author.append(badge());
    const rating=document.createElement('div');rating.className='thr-rating';const stars=document.createElement('span');stars.className='thr-stars';stars.style.setProperty('--rating-fill',Math.max(0,Math.min(5,Number(review.rating)||0))*20+'%');stars.innerHTML='<span>★★★★★</span><span>★★★★★</span>';stars.setAttribute('aria-label',review.rating+' out of 5 stars');rating.append(stars);
    const quote=document.createElement('blockquote');quote.textContent=review.review;quote.style.whiteSpace='pre-line';body.append(author,rating,quote,purchaseRow());c.append(body);grid.append(c);cards.push(c);return c;
   }
   more?.addEventListener('click',async()=>{more.disabled=true;status.textContent='';try{
    const batch=cards.filter(c=>c.hidden).slice(0,24);batch.forEach(c=>c.hidden=false);
    if(batch.length<24){if(extra===null){const response=await fetch(section.dataset.reviewSource);if(!response.ok)throw Error('Load failed');extra=await response.json()}while(batch.length<24&&cursor<extra.length)batch.push(makeCard(extra[cursor++]));}
    update();batch[0]?.focus({preventScroll:true});
   }catch(e){status.textContent='Unable to load more reviews. Please try again.'}finally{more.disabled=false}});
   section.addEventListener('shopify:block:select',e=>{const c=e.target.closest('[data-review-card]');if(c)open(c)});
  });
 }
 initReviews();document.addEventListener('shopify:section:load',e=>initReviews(e.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heary-b-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initReviews(scope = document) {
    scope.querySelectorAll('[data-heary-reviews]').forEach(section => {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = 'true';
      const cards = [...section.querySelectorAll('[data-review-card]')];
      const more = section.querySelector('[data-review-more]');
      const count = section.querySelector('[data-review-shown]');
      function update() { const shown = cards.filter(card => !card.hidden).length; count.textContent = shown; if (more) more.hidden = shown === cards.length; }
      more?.addEventListener('click', () => { const next = cards.filter(card => card.hidden).slice(0,6); next.forEach(card => card.hidden = false); update(); next[0]?.focus({preventScroll:true}); });
      section.addEventListener('shopify:block:select', event => { const index = cards.indexOf(event.target); if (index >= 0) { cards.slice(0,index+1).forEach(card => card.hidden = false); update(); } });
    });
  }
  initReviews();
  document.addEventListener('shopify:section:load', event => initReviews(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heary-presell-offer"]) return;
  try {
    
document.querySelectorAll('.hp-sticky').forEach(bar=>{const offer=document.querySelector('#hp-offer');if(offer&&'IntersectionObserver' in window){new IntersectionObserver(entries=>{bar.classList.toggle('is-hidden',entries[0].isIntersecting);},{threshold:.2}).observe(offer);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tryheary-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initReviews(scope = document) {
    scope.querySelectorAll('[data-heary-reviews]').forEach(section => {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = 'true';
      const cards = [...section.querySelectorAll('[data-review-card]')];
      const more = section.querySelector('[data-review-more]');
      const count = section.querySelector('[data-review-shown]');
      function update() { const shown = cards.filter(card => !card.hidden).length; count.textContent = shown; if (more) more.hidden = shown === cards.length; }
      more?.addEventListener('click', () => { const next = cards.filter(card => card.hidden).slice(0,6); next.forEach(card => card.hidden = false); update(); next[0]?.focus({preventScroll:true}); });
      section.addEventListener('shopify:block:select', event => { const index = cards.indexOf(event.target); if (index >= 0) { cards.slice(0,index+1).forEach(card => card.hidden = false); update(); } });
    });
  }
  initReviews();
  document.addEventListener('shopify:section:load', event => initReviews(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
